import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-become-member',
  templateUrl: './become-member.component.html',
  styleUrl: './become-member.component.scss'
})
export class BecomeMemberComponent implements OnInit {
  @Input() set stepData(step: any) {
    if (step !== undefined) {
      this.currentStep = step;
    }
  }

  currentStep: number = 1;

  ngOnInit() {
  }
}
